import React, { useState } from 'react';
import { X, Plus, Trash2 } from 'lucide-react';

const MilestoneModal = ({ show, onClose, onSubmit, engagementId }) => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    dueDate: '',
    expectedOutput: '',
    deliverables: ['']
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const milestoneData = {
      engagementId,
      title: formData.title,
      description: formData.description,
      dueDate: formData.dueDate,
      expectedOutput: formData.expectedOutput,
      deliverables: formData.deliverables.filter(d => d.trim() !== '')
    };

    await onSubmit(milestoneData);
    
    // Reset form
    setFormData({
      title: '',
      description: '',
      dueDate: '',
      expectedOutput: '',
      deliverables: ['']
    });
  };

  const addDeliverable = () => {
    setFormData({
      ...formData,
      deliverables: [...formData.deliverables, '']
    });
  };

  const updateDeliverable = (index, value) => {
    const newDeliverables = [...formData.deliverables];
    newDeliverables[index] = value;
    setFormData({
      ...formData,
      deliverables: newDeliverables
    });
  };

  const removeDeliverable = (index) => {
    const newDeliverables = formData.deliverables.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      deliverables: newDeliverables
    });
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-background rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-border flex items-center justify-between sticky top-0 bg-background">
          <h2 className="heading-3 text-foreground">
            Create New Milestone
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-lg transition-all"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div>
            <label className="label mb-2 block">
              Milestone Title *
            </label>
            <input
              type="text"
              required
              value={formData.title}
              onChange={(e) => setFormData({...formData, title: e.target.value})}
              className="input-base"
              placeholder="e.g., Complete Baseline Survey"
            />
          </div>

          <div>
            <label className="label mb-2 block">
              Description *
            </label>
            <textarea
              required
              rows="4"
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              className="input-base resize-none"
              placeholder="Describe what needs to be achieved..."
            />
          </div>

          <div>
            <label className="label mb-2 block">
              Due Date *
            </label>
            <input
              type="date"
              required
              value={formData.dueDate}
              onChange={(e) => setFormData({...formData, dueDate: e.target.value})}
              className="input-base"
            />
          </div>

          <div>
            <label className="label mb-2 block">
              Expected Output
            </label>
            <input
              type="text"
              value={formData.expectedOutput}
              onChange={(e) => setFormData({...formData, expectedOutput: e.target.value})}
              className="input-base"
              placeholder="e.g., Survey report with 500 responses"
            />
          </div>

          <div>
            <div className="flex items-center justify-between mb-3">
              <label className="label">
                Deliverables
              </label>
              <button
                type="button"
                onClick={addDeliverable}
                className="text-sm font-medium flex items-center gap-1 hover:opacity-80"
                style={{ color: 'hsl(75 25% 45%)' }}
              >
                <Plus className="w-4 h-4" />
                Add Deliverable
              </button>
            </div>
            <div className="space-y-2">
              {formData.deliverables.map((deliverable, index) => (
                <div key={index} className="flex gap-2">
                  <input
                    type="text"
                    value={deliverable}
                    onChange={(e) => updateDeliverable(index, e.target.value)}
                    className="input-base flex-1"
                    placeholder={`Deliverable ${index + 1}`}
                  />
                  {formData.deliverables.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeDeliverable(index)}
                      className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-all"
                    >
                      <Trash2 className="w-5 h-5" />
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="flex gap-4 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="btn-outline flex-1 btn-lg"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-primary flex-1 btn-lg"
            >
              Create Milestone
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MilestoneModal;
